export default __webpack_public_path__ + "static/media/svg-7.ff2b2030.svg";